<template>
    <kgr-lightbox
        :value="show"
        :headline="$t('Hinweis')"
        scrollable
        @post-input="$emit('close')"
    >
        <div
            v-if="invoicesWithAlreadySentDunningEmail.length > 0"
            class="kgr-text"
        >
            {{ $t('An {amount} Mitglieder wurde die Mahnung bereits per E-Mail verschickt.', { amount: invoicesWithAlreadySentDunningEmail.length }) }}
            {{ $t('Möchtest du diese Mahndokumente wirklich erneut per Mail versenden?') }}
        </div>
        <div
            v-else
            class="kgr-text"
        >
            {{ $t('Möchtest du diese Mahndokumente per Mail versenden?') }}
        </div>
        <template #footer>
            <button
                class="kgr-button"
                @click="$emit('close')"
            >
                {{ $t('cancel') }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('confirm')"
            >
                {{ $t('Ok') }}
            </button>
        </template>
    </kgr-lightbox>
</template>

<script>
import Lightbox from '../../common/modal/Lightbox.vue';

export default {
    components: {
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        invoices: {
            type: Array,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
    computed: {
        invoicesWithAlreadySentDunningEmail() {
            return this.invoices.filter((invoice) => {
                const dunningStatus = invoice.dunningStatus.status;
                return invoice.dunningPdfs[dunningStatus] !== undefined
                    && invoice.dunningPdfs[dunningStatus].lastEmailSent !== null;
            });
        },
    },
};
</script>
